import React, { useState } from 'react';
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Divider,
  Tooltip
} from '@mui/material';
import {
  Download,
  Description,      // ← Remplacer FileExcel par Description
  PictureAsPdf,      // ← Celui-ci existe
  TableChart,
  Summarize          // ← Alternative pour Excel
} from '@mui/icons-material';

const ExportButton = ({ onExportExcel, onExportPDF, disabled = false, variant = 'contained' }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleExportExcel = () => {
    if (onExportExcel) onExportExcel();
    handleClose();
  };

  const handleExportPDF = () => {
    if (onExportPDF) onExportPDF();
    handleClose();
  };

  return (
    <>
      <Tooltip title="Exporter les données">
        <Button
          variant={variant}
          startIcon={<Download />}
          onClick={handleClick}
          disabled={disabled}
          sx={{
            background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
            '&:hover': {
              background: 'linear-gradient(135deg, #5a67d8 0%, #6b46c1 100%)'
            }
          }}
        >
          Exporter
        </Button>
      </Tooltip>

      <Menu
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        transformOrigin={{ horizontal: 'right', vertical: 'top' }}
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        PaperProps={{
          sx: {
            mt: 1,
            width: 200,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)'
          }
        }}
      >
        <MenuItem onClick={handleExportExcel} sx={{ py: 1 }}>
          <ListItemIcon>
            <Description sx={{ color: '#10b981' }} />
          </ListItemIcon>
          <ListItemText primary="Excel (.xlsx)" />
        </MenuItem>
        <MenuItem onClick={handleExportPDF} sx={{ py: 1 }}>
          <ListItemIcon>
            <PictureAsPdf sx={{ color: '#ef4444' }} />
          </ListItemIcon>
          <ListItemText primary="PDF (.pdf)" />
        </MenuItem>
        <Divider />
        <MenuItem disabled sx={{ opacity: 0.6 }}>
          <ListItemIcon>
            <TableChart fontSize="small" />
          </ListItemIcon>
          <ListItemText primary="Plus d'options..." secondary="Bientôt disponible" />
        </MenuItem>
      </Menu>
    </>
  );
};

export default ExportButton;

